// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file dev/moment/differential/v1alpha1/store.proto (package dev.moment.differential.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Value } from "@bufbuild/protobuf";

/**
 * @generated from message dev.moment.differential.v1alpha1.Tuple
 */
export class Tuple extends Message<Tuple> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: google.protobuf.Value value = 2;
   */
  value?: Value;

  /**
   * @generated from field: optional string owner = 3;
   */
  owner?: string;

  constructor(data?: PartialMessage<Tuple>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.Tuple";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Value },
    { no: 3, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Tuple {
    return new Tuple().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Tuple {
    return new Tuple().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Tuple {
    return new Tuple().fromJsonString(jsonString, options);
  }

  static equals(a: Tuple | PlainMessage<Tuple> | undefined, b: Tuple | PlainMessage<Tuple> | undefined): boolean {
    return proto3.util.equals(Tuple, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TableSpec
 */
export class TableSpec extends Message<TableSpec> {
  /**
   * @generated from field: repeated dev.moment.differential.v1alpha1.TablePermission permissions = 1;
   */
  permissions: TablePermission[] = [];

  /**
   * @generated from field: repeated dev.moment.differential.v1alpha1.Tuple initial_table_data = 2;
   */
  initialTableData: Tuple[] = [];

  constructor(data?: PartialMessage<TableSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TableSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "permissions", kind: "message", T: TablePermission, repeated: true },
    { no: 2, name: "initial_table_data", kind: "message", T: Tuple, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableSpec {
    return new TableSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableSpec {
    return new TableSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableSpec {
    return new TableSpec().fromJsonString(jsonString, options);
  }

  static equals(a: TableSpec | PlainMessage<TableSpec> | undefined, b: TableSpec | PlainMessage<TableSpec> | undefined): boolean {
    return proto3.util.equals(TableSpec, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TablePermission
 */
export class TablePermission extends Message<TablePermission> {
  /**
   * See docsapi for the expected shape
   *
   * @generated from field: google.protobuf.Value value = 1;
   */
  value?: Value;

  constructor(data?: PartialMessage<TablePermission>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TablePermission";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "message", T: Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TablePermission {
    return new TablePermission().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TablePermission {
    return new TablePermission().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TablePermission {
    return new TablePermission().fromJsonString(jsonString, options);
  }

  static equals(a: TablePermission | PlainMessage<TablePermission> | undefined, b: TablePermission | PlainMessage<TablePermission> | undefined): boolean {
    return proto3.util.equals(TablePermission, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.ZSet
 */
export class ZSet extends Message<ZSet> {
  /**
   * @generated from field: repeated dev.moment.differential.v1alpha1.ZTuple tuples = 1;
   */
  tuples: ZTuple[] = [];

  constructor(data?: PartialMessage<ZSet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.ZSet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tuples", kind: "message", T: ZTuple, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ZSet {
    return new ZSet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ZSet {
    return new ZSet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ZSet {
    return new ZSet().fromJsonString(jsonString, options);
  }

  static equals(a: ZSet | PlainMessage<ZSet> | undefined, b: ZSet | PlainMessage<ZSet> | undefined): boolean {
    return proto3.util.equals(ZSet, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.ZTuple
 */
export class ZTuple extends Message<ZTuple> {
  /**
   * @generated from field: dev.moment.differential.v1alpha1.Tuple tuple = 1;
   */
  tuple?: Tuple;

  /**
   * @generated from field: double weight = 2;
   */
  weight = 0;

  constructor(data?: PartialMessage<ZTuple>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.ZTuple";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tuple", kind: "message", T: Tuple },
    { no: 2, name: "weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ZTuple {
    return new ZTuple().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ZTuple {
    return new ZTuple().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ZTuple {
    return new ZTuple().fromJsonString(jsonString, options);
  }

  static equals(a: ZTuple | PlainMessage<ZTuple> | undefined, b: ZTuple | PlainMessage<ZTuple> | undefined): boolean {
    return proto3.util.equals(ZTuple, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.Store
 */
export class Store extends Message<Store> {
  /**
   * @generated from field: bool created = 1;
   */
  created = false;

  /**
   * @generated from field: double current_epoch = 2;
   */
  currentEpoch = 0;

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.TableSpec> table_specs = 3;
   */
  tableSpecs: { [key: string]: TableSpec } = {};

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.ZSet> tables = 4;
   */
  tables: { [key: string]: ZSet } = {};

  /**
   * @generated from field: map<string, google.protobuf.Value> query_specs_json = 5;
   */
  querySpecsJson: { [key: string]: Value } = {};

  /**
   * @generated from field: map<string, google.protobuf.Value> query_states_json = 6;
   */
  queryStatesJson: { [key: string]: Value } = {};

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.ZSet> query_results = 7;
   */
  queryResults: { [key: string]: ZSet } = {};

  /**
   * @generated from field: repeated google.protobuf.Value actions_json = 8;
   */
  actionsJson: Value[] = [];

  /**
   * @generated from field: bool archived = 9;
   */
  archived = false;

  constructor(data?: PartialMessage<Store>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.Store";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "created", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "current_epoch", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "table_specs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSpec} },
    { no: 4, name: "tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ZSet} },
    { no: 5, name: "query_specs_json", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
    { no: 6, name: "query_states_json", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
    { no: 7, name: "query_results", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ZSet} },
    { no: 8, name: "actions_json", kind: "message", T: Value, repeated: true },
    { no: 9, name: "archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Store {
    return new Store().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Store {
    return new Store().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Store {
    return new Store().fromJsonString(jsonString, options);
  }

  static equals(a: Store | PlainMessage<Store> | undefined, b: Store | PlainMessage<Store> | undefined): boolean {
    return proto3.util.equals(Store, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.EnsureCreatedRequest
 */
export class EnsureCreatedRequest extends Message<EnsureCreatedRequest> {
  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.TableSpec> tables = 1;
   */
  tables: { [key: string]: TableSpec } = {};

  constructor(data?: PartialMessage<EnsureCreatedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.EnsureCreatedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSpec} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCreatedRequest | PlainMessage<EnsureCreatedRequest> | undefined, b: EnsureCreatedRequest | PlainMessage<EnsureCreatedRequest> | undefined): boolean {
    return proto3.util.equals(EnsureCreatedRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.EnsureCreatedResponse
 */
export class EnsureCreatedResponse extends Message<EnsureCreatedResponse> {
  constructor(data?: PartialMessage<EnsureCreatedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.EnsureCreatedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCreatedResponse | PlainMessage<EnsureCreatedResponse> | undefined, b: EnsureCreatedResponse | PlainMessage<EnsureCreatedResponse> | undefined): boolean {
    return proto3.util.equals(EnsureCreatedResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.RegisterQueryRequest
 */
export class RegisterQueryRequest extends Message<RegisterQueryRequest> {
  /**
   * @generated from field: google.protobuf.Value query_json = 1;
   */
  queryJson?: Value;

  constructor(data?: PartialMessage<RegisterQueryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.RegisterQueryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query_json", kind: "message", T: Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterQueryRequest {
    return new RegisterQueryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterQueryRequest {
    return new RegisterQueryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterQueryRequest {
    return new RegisterQueryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterQueryRequest | PlainMessage<RegisterQueryRequest> | undefined, b: RegisterQueryRequest | PlainMessage<RegisterQueryRequest> | undefined): boolean {
    return proto3.util.equals(RegisterQueryRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.RegisterQueryResponse
 */
export class RegisterQueryResponse extends Message<RegisterQueryResponse> {
  /**
   * @generated from field: string query_id = 1;
   */
  queryId = "";

  constructor(data?: PartialMessage<RegisterQueryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.RegisterQueryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterQueryResponse {
    return new RegisterQueryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterQueryResponse {
    return new RegisterQueryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterQueryResponse {
    return new RegisterQueryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterQueryResponse | PlainMessage<RegisterQueryResponse> | undefined, b: RegisterQueryResponse | PlainMessage<RegisterQueryResponse> | undefined): boolean {
    return proto3.util.equals(RegisterQueryResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.MutateTableRequest
 */
export class MutateTableRequest extends Message<MutateTableRequest> {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId = "";

  /**
   * @generated from field: google.protobuf.Value mutation_json = 2;
   */
  mutationJson?: Value;

  /**
   * @generated from field: string intent_id = 3;
   */
  intentId = "";

  constructor(data?: PartialMessage<MutateTableRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.MutateTableRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mutation_json", kind: "message", T: Value },
    { no: 3, name: "intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MutateTableRequest {
    return new MutateTableRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MutateTableRequest {
    return new MutateTableRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MutateTableRequest {
    return new MutateTableRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MutateTableRequest | PlainMessage<MutateTableRequest> | undefined, b: MutateTableRequest | PlainMessage<MutateTableRequest> | undefined): boolean {
    return proto3.util.equals(MutateTableRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.MutateTableResponse
 */
export class MutateTableResponse extends Message<MutateTableResponse> {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId = "";

  /**
   * @generated from field: dev.moment.differential.v1alpha1.Error error = 2;
   */
  error?: Error;

  constructor(data?: PartialMessage<MutateTableResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.MutateTableResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transaction_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "error", kind: "message", T: Error },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MutateTableResponse {
    return new MutateTableResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MutateTableResponse {
    return new MutateTableResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MutateTableResponse {
    return new MutateTableResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MutateTableResponse | PlainMessage<MutateTableResponse> | undefined, b: MutateTableResponse | PlainMessage<MutateTableResponse> | undefined): boolean {
    return proto3.util.equals(MutateTableResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TableStateRequest
 */
export class TableStateRequest extends Message<TableStateRequest> {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId = "";

  constructor(data?: PartialMessage<TableStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TableStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableStateRequest {
    return new TableStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableStateRequest {
    return new TableStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableStateRequest {
    return new TableStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TableStateRequest | PlainMessage<TableStateRequest> | undefined, b: TableStateRequest | PlainMessage<TableStateRequest> | undefined): boolean {
    return proto3.util.equals(TableStateRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TableStateResponse
 */
export class TableStateResponse extends Message<TableStateResponse> {
  /**
   * @generated from field: repeated dev.moment.differential.v1alpha1.Tuple tuples = 1;
   */
  tuples: Tuple[] = [];

  /**
   * @generated from field: double current_epoch = 2;
   */
  currentEpoch = 0;

  constructor(data?: PartialMessage<TableStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TableStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tuples", kind: "message", T: Tuple, repeated: true },
    { no: 2, name: "current_epoch", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableStateResponse {
    return new TableStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableStateResponse {
    return new TableStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableStateResponse {
    return new TableStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TableStateResponse | PlainMessage<TableStateResponse> | undefined, b: TableStateResponse | PlainMessage<TableStateResponse> | undefined): boolean {
    return proto3.util.equals(TableStateResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TableChangesRequest
 */
export class TableChangesRequest extends Message<TableChangesRequest> {
  /**
   * @generated from field: optional string table_id = 1;
   */
  tableId?: string;

  /**
   * @generated from field: double from_version = 2;
   */
  fromVersion = 0;

  constructor(data?: PartialMessage<TableChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TableChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "from_version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableChangesRequest {
    return new TableChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableChangesRequest {
    return new TableChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableChangesRequest {
    return new TableChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TableChangesRequest | PlainMessage<TableChangesRequest> | undefined, b: TableChangesRequest | PlainMessage<TableChangesRequest> | undefined): boolean {
    return proto3.util.equals(TableChangesRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.TableChangesResponse
 */
export class TableChangesResponse extends Message<TableChangesResponse> {
  /**
   * @generated from field: repeated google.protobuf.Value changes_json = 1;
   */
  changesJson: Value[] = [];

  constructor(data?: PartialMessage<TableChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.TableChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "changes_json", kind: "message", T: Value, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableChangesResponse {
    return new TableChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableChangesResponse {
    return new TableChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableChangesResponse {
    return new TableChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TableChangesResponse | PlainMessage<TableChangesResponse> | undefined, b: TableChangesResponse | PlainMessage<TableChangesResponse> | undefined): boolean {
    return proto3.util.equals(TableChangesResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.QueryStateRequest
 */
export class QueryStateRequest extends Message<QueryStateRequest> {
  /**
   * @generated from field: string query_id = 1;
   */
  queryId = "";

  constructor(data?: PartialMessage<QueryStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.QueryStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryStateRequest {
    return new QueryStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryStateRequest {
    return new QueryStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryStateRequest {
    return new QueryStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: QueryStateRequest | PlainMessage<QueryStateRequest> | undefined, b: QueryStateRequest | PlainMessage<QueryStateRequest> | undefined): boolean {
    return proto3.util.equals(QueryStateRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.QueryStateResponse
 */
export class QueryStateResponse extends Message<QueryStateResponse> {
  /**
   * @generated from field: repeated dev.moment.differential.v1alpha1.Tuple tuples = 1;
   */
  tuples: Tuple[] = [];

  /**
   * @generated from field: double current_epoch = 2;
   */
  currentEpoch = 0;

  constructor(data?: PartialMessage<QueryStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.QueryStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tuples", kind: "message", T: Tuple, repeated: true },
    { no: 2, name: "current_epoch", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryStateResponse {
    return new QueryStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryStateResponse {
    return new QueryStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryStateResponse {
    return new QueryStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: QueryStateResponse | PlainMessage<QueryStateResponse> | undefined, b: QueryStateResponse | PlainMessage<QueryStateResponse> | undefined): boolean {
    return proto3.util.equals(QueryStateResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.QueryChangesRequest
 */
export class QueryChangesRequest extends Message<QueryChangesRequest> {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId = "";

  /**
   * @generated from field: double from_version = 2;
   */
  fromVersion = 0;

  constructor(data?: PartialMessage<QueryChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.QueryChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "from_version", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryChangesRequest {
    return new QueryChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryChangesRequest {
    return new QueryChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryChangesRequest {
    return new QueryChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: QueryChangesRequest | PlainMessage<QueryChangesRequest> | undefined, b: QueryChangesRequest | PlainMessage<QueryChangesRequest> | undefined): boolean {
    return proto3.util.equals(QueryChangesRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.QueryChangesResponse
 */
export class QueryChangesResponse extends Message<QueryChangesResponse> {
  /**
   * @generated from field: repeated google.protobuf.Value changes_json = 1;
   */
  changesJson: Value[] = [];

  constructor(data?: PartialMessage<QueryChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.QueryChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "changes_json", kind: "message", T: Value, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryChangesResponse {
    return new QueryChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryChangesResponse {
    return new QueryChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryChangesResponse {
    return new QueryChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: QueryChangesResponse | PlainMessage<QueryChangesResponse> | undefined, b: QueryChangesResponse | PlainMessage<QueryChangesResponse> | undefined): boolean {
    return proto3.util.equals(QueryChangesResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.ArchiveRequest
 */
export class ArchiveRequest extends Message<ArchiveRequest> {
  constructor(data?: PartialMessage<ArchiveRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.ArchiveRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveRequest {
    return new ArchiveRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveRequest | PlainMessage<ArchiveRequest> | undefined, b: ArchiveRequest | PlainMessage<ArchiveRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.ArchiveResponse
 */
export class ArchiveResponse extends Message<ArchiveResponse> {
  constructor(data?: PartialMessage<ArchiveResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.ArchiveResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveResponse {
    return new ArchiveResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveResponse | PlainMessage<ArchiveResponse> | undefined, b: ArchiveResponse | PlainMessage<ArchiveResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha1.Error
 */
export class Error extends Message<Error> {
  /**
   * @generated from field: string message = 1;
   */
  message = "";

  constructor(data?: PartialMessage<Error>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha1.Error";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Error {
    return new Error().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Error {
    return new Error().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Error {
    return new Error().fromJsonString(jsonString, options);
  }

  static equals(a: Error | PlainMessage<Error> | undefined, b: Error | PlainMessage<Error> | undefined): boolean {
    return proto3.util.equals(Error, a, b);
  }
}

